import { useEffect } from 'react';

export const useOutsideClick = (ref, callback=()=>null, hasTrue=false) => {
  const handleClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback(false);
    } else {
      // hasTrue ? callback(e):null
    }
  };

  useEffect(() => {
    setTimeout(() => {
      document.addEventListener('click', handleClick);
    }, 100);
    return () => {
      document.removeEventListener('click', handleClick);
    };

  });
};

export const useOutsideHover = (ref, callback) => {
  const handleClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback(false);
    }
    // else {
    //   callback(true)
    // }
  };

  useEffect(() => {
    setTimeout(() => {
      document.addEventListener('mousemove', handleClick);
    }, 100);
    return () => {
      document.removeEventListener('mousemove', handleClick);
    };

  });
};

export default useOutsideClick;
